// @ts-nocheck
import { Trans } from '@lingui/react'
import { useDispatch, useSelector } from 'react-redux'

import { putPrescriptionFollowsAction } from 'shared/store/ducks/cart'
import { type IState } from 'types/redux/store'
import InputCheckbox from 'views/components/molecules/InputCheckbox'
import PrescriptionFollowsModal from 'views/components/organisms/Checkout/PrescriptionFollowsModal'
import { PRESCRIPTION_FOLLOWS_MODAL } from 'views/components/organisms/Checkout/PrescriptionFollowsModal/names'

const PrescriptionFollowsBox = () => {
  const dispatch = useDispatch()

  const isPrescriptionFollowsStatus = useSelector(
    (state: IState) => state.cart.data?.prescriptionFollows
  )

  return (
    <span className="l-flex l-flex--start u-padding--top">
      <InputCheckbox
        id="prescriptionFollows"
        name="cart-sumBox-prescriptionFollows-input"
        checked={isPrescriptionFollowsStatus}
        onClick={() =>
          dispatch(putPrescriptionFollowsAction(!isPrescriptionFollowsStatus))
        }
      >
        {''}
      </InputCheckbox>
      <p className="u-no-margin--bottom m-PrescriptionFollowsBox__text">
        <Trans id="cart.prescriptionFollows.checkbox" />
        <u
          data-a11y-dialog-show={PRESCRIPTION_FOLLOWS_MODAL}
          className="u-margin-xx-small--left m-PrescriptionFollowsBox__link"
          style={{ cursor: 'pointer' }}
        >
          <Trans id="general.more.information.short" />
        </u>
        <sup>3,11</sup>
      </p>
      <PrescriptionFollowsModal />
    </span>
  )
}

export default PrescriptionFollowsBox
